import React, { Component } from "react";
import { FaCocktail, FaBeer } from "react-icons/fa";
import Title from "./Title";
export default class Services extends Component {
  state = {
    services: [
      {
        icon: <FaCocktail />,
        title: "Equipa Poliglota",
        info:
          "Lorem ipsum, dolor sit amet consectetur adipisicing elit."
      },
      {
        icon: <FaBeer />,
        title: "Quartos para Deficientes",
        info:
          "Lorem ipsum, dolor sit amet consectetur adipisicing elit."
      },
      {
        icon: <FaBeer />,
        title: "Lavandaria/Limpeza a seco",
        info:
          "Lorem ipsum, dolor sit amet consectetur adipisicing elit."
      },
      {
        icon: <FaBeer />,
        title: "Bagageira",
        info:
          "Lorem ipsum, dolor sit amet consectetur adipisicing elit."
      },
      {
        icon: <FaBeer />,
        title: "Kids Club",
        info:
          "Lorem ipsum, dolor sit amet consectetur adipisicing elit."
      },
      {
        icon: <FaBeer />,
        title: "Outdoor Swimming-Pool",
        info:
          "Lorem ipsum, dolor sit amet consectetur adipisicing elit."
      },
      {
        icon: <FaBeer />,
        title: "Swimming-Pool",
        info:
          "Lorem ipsum, dolor sit amet consectetur adipisicing elit."
      },
      {
        icon: <FaBeer />,
        title: "Restaurante Buffet",
        info:
          "Lorem ipsum, dolor sit amet consectetur adipisicing elit."
      },
      {
        icon: <FaBeer />,
        title: "Business",
        info:
          "Lorem ipsum, dolor sit amet consectetur adipisicing elit."
      },
      {
        icon: <FaBeer />,
        title: "Ginásio Gratuito",
        info:
          "Lorem ipsum, dolor sit amet consectetur adipisicing elit."
      },
      {
        icon: <FaBeer />,
        title: "Serviço de Casamentos",
        info:
          "Lorem ipsum, dolor sit amet consectetur adipisicing elit."
      },
      {
        icon: <FaBeer />,
        title: "Serviço de Estacionamento com manobrista",
        info:
          "Lorem ipsum, dolor sit amet consectetur adipisicing elit."
      },
    ]
  };
  render() {
    return (
      <section className="services">
        <Title title="serviços" />
        <div className="services-center">
          {this.state.services.map(item => {
            return (
              <article key={`item-${item.title}`} className="service">
                {/*
                <span>{item.icon}</span>
                 */}
                <h6>{item.title}</h6>
                {/*
                <p>{item.info}</p>
                 */}
              </article>
            );
          })}
        </div>
      </section>
    );
  }
}
